import React, {useCallback} from 'react';

import EllipsisTextHint from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import IconButton from '@pb/kit-component-icon-button';
import {Tooltip} from '@pb/kit-component-popups';
import {useShown} from '@pb/kit-hooks-use-shown';

import {RemoveNoteModal} from './remove-note-modal';

import {apiV2ReleaseNotesDetails, apiV2ReleaseNotesEditButton} from './release-notes.module.styl';

type Props = {
    id: number,
    version: string,
    releaseDate: string,
    scope: string,
    details: string,
    editNote: (id: number) => void,
    onRemoveNote: (id: number) => void,
    loading: boolean,
    isEdited?: boolean,
    canEdit: boolean,
};

export const ReleaseNoteItem = (props: Props) => {

    const {shown, onClick, onClose} = useShown();

    const {id, version, releaseDate, scope, details, editNote, onRemoveNote, loading, canEdit} = props;

    const onRemove = useCallback(() => {
        onRemoveNote(id);
    }, [onRemoveNote, id]);

    const onEdit = useCallback(() => {
        editNote(id);
    }, [editNote, id]);

    return (
        <>
            <Group justify="start" alignItems="start">
                <Item style={{width: 100}} shrink={0}>
                    {version}
                </Item>
                <Item style={{width: 150}} shrink={0}>
                    {releaseDate}
                </Item>
                <Item style={{width: 100}} shrink={0}>
                    <EllipsisTextHint>{scope}</EllipsisTextHint>
                </Item>
                <Item grow={1} className={apiV2ReleaseNotesDetails}>
                    {details.split('\n').map((paragraph, index) => (<p key={index}>{paragraph}</p>))}
                </Item>
                {canEdit ? (
                    <Group direction="v" gap="none">
                        <Tooltip
                            color="light"
                            anchor={({anchorRef, getAnchorProps}) => (
                                <IconButton
                                    ref={anchorRef}
                                    {...getAnchorProps()}
                                    className={apiV2ReleaseNotesEditButton}
                                    iconProps={{type: Icons.PENCIL}}
                                    onClick={onEdit}
                                />
                            )}>
                            Edit Note
                        </Tooltip>
                        <Tooltip
                            color="light"
                            anchor={({anchorRef, getAnchorProps}) => (
                                <IconButton
                                    ref={anchorRef}
                                    {...getAnchorProps()}
                                    iconProps={{type: Icons.REMOVE}}
                                    onClick={onClick}
                                />
                            )}>
                            Remove Note
                        </Tooltip>
                    </Group>
                ) : null}
            </Group>
            {shown ? <RemoveNoteModal onClose={onClose} busy={loading} onRemoveNote={onRemove}/> : null}
        </>
    );
};
